import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { fetchSite } from '../services/site.service';
import { Site } from '../types';
import { IGeographicAddress } from '@features/eligibility/interfaces';

interface LoadSiteProps {
  addressInfos: IGeographicAddress;
}

interface OrderListState {
  lastApiError: string | undefined;
  isSiteLoading: boolean;
  site: Site | undefined;
}

const initialState: OrderListState = {
  isSiteLoading: false,
  site: undefined,
  lastApiError: undefined
};

export const loadSite = createAsyncThunk<Site, LoadSiteProps, { rejectValue: Error }>(
  'site/loadSite',
  async (params, { rejectWithValue }) => {
    const { addressInfos } = params;
    try {
      const response = await fetchSite(addressInfos);
      return response.data;
    } catch (e) {
      const error = e as Error;
      if (!error.message) {
        throw error;
      }
      return rejectWithValue(error);
    }
  }
);

const siteSlice = createSlice({
  name: 'site',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadSite.pending, (state) => {
        state.isSiteLoading = true;
        state.site = undefined;
        state.lastApiError = undefined;
      })
      .addCase(loadSite.fulfilled, (state, { payload }) => {
        state.isSiteLoading = false;
        state.site = payload;
        state.lastApiError = undefined;
      })
      .addCase(loadSite.rejected, (state, { error }) => {
        state.isSiteLoading = false;
        state.lastApiError = error.message;
        state.site = undefined;
      });
  }
});

export default siteSlice.reducer;
